import React from 'react'
import { Widget } from '@typeform/embed-react'
import { Container, Row } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { signout } from '../../redux/actions/userActions'
import '../../scss/component/assessments/assessment.scss';
class AssessmentForms extends React.Component {
  state={
    showTourButton:false
  }

  render () {
    const {setShowTourButton} = this.props;
    let url = this.props.url;
    url = url.replace("https://postured.typeform.com/to/","");
    let formID = url.split('?')[0];
    const tenantId = localStorage.getItem('tenant')
    return (
      <Container
        className={`typeform-container ${this.props.i === this.props.categoryIndex ? 'display' : 'invisible'}`}
        key={uuid()}>
        <Row>
          <Widget 
            id={formID} 
            className="box" 
            onSubmit={()=>{setShowTourButton()}}
            hidden={{
              tenantid:tenantId,
              frameworkname:this.props.frameworkName,
              frameworkid:this.props.frameworkId
            }}
          />
        </Row>
      </Container>
    )
  }
}
export default connect(null, { signout })(withRouter(AssessmentForms))



// WEBPACK FOOTER //
// ./src/components/assessment/TypeformView.js